module.exports = __webpack_public_path__ + "static/media/non_ulip.1728a9f2.mp3";